import React from 'react';
import PortfolioItem from './portfolioItem';
import signLanguage from './portfolio/signLanguage.jpg';

const portfolioData = [
    {
        title: 'Environment-Agnostic RF Fingerprinting through Protocol-Compliant IQ Imbalance Estimation',
        filterClass: 'filter-research',
        stack: 'TensorFlow, CNN, MATLAB, GNU Radio, Signal Processing, USRP SDR, Testbed Setup',
        description: 'An experimental architecture evaluating physical-layer identity markers via protocol-compliant IQ tracking mechanisms to isolate stable device identities.',
        iconClass: 'bi bi-broadcast',
        footerText: 'IEEE CNS 2026'
    },
    {
        title: 'An Adversarial-Driven Experimental Study on Deep Learning for RF Fingerprinting',
        filterClass: 'filter-research',
        stack: 'TensorFlow, CNN, MATLAB, GNU Radio, Signal Processing, USRP SDR, Testbed Setup',
        description: 'End-to-end signal processing and deep learning pipeline designed to isolate device-specific hardware signatures from raw I/Q data under adversarial testing constraints.',
        iconClass: 'bi bi-journal-text',
        footerText: 'IEEE MILCOM 2025'
    },
    {
        title: 'Modular Enterprise ERP Engine',
        filterClass: 'filter-enterprise',
        stack: 'Laravel, PostgreSQL, MySQL, RESTful APIs, PHP, JavaScript, Redis',
        description: 'Production business logic layer handling heavy transactional relationships, complex database query structures, and external billing microservice architectures.',
        iconClass: 'bi bi-layer-wardrobe',
        footerText: 'Enterprise Systems'
    },
    {
        title: 'Fullstack Portal Management System',
        filterClass: 'filter-enterprise',
        stack: 'React JS, Laravel, REST APIs, MySQL, PostgreSQL, Redis',
        description: 'Decoupled web portal managing atomic application flows, reactive frontend states, and scalable backend relational databases across enterprise endpoints.',
        iconClass: 'bi bi-person-check',
        footerText: 'Fullstack Platform'
    },
    {
        title: 'Crypto Currency Portfolio Management System',
        filterClass: 'filter-enterprise',
        stack: 'Restful APIs, Laravel, MySQL, Redis, PHP, JavaScript',
        description: 'A general portfolio for managing cryptocurrency. This allows you to create your own portfolio where you can store all your crypto transactions. It fetches the current price and calculates your returns and several other statistics. It contains around 18k+ virtual currency that gets updated every hour. The prices are fetched live.',
        iconClass: 'bi bi-eye',
        footerText: 'Fullstack Platform Vision'
    },
    {
        title: 'Sign Language Recognition Engine',
        filterClass: 'filter-research',
        stack: 'Python, OpenCV, TensorFlow, Mediapipe',
        description: 'Real-time deep learning tracking system implementing spatial coordinate mapping and predictive classification matrices to model frame transitions.',
        imageSrc: signLanguage,
        iconClass: 'bi bi-eye',
        footerText: 'Computer Vision'
    }
];

const PortfolioContainer = ({ activeFilter }) => {
    // Filter the items natively using React state rules instead of relying on external jQuery libraries
    const filteredData = portfolioData.filter((item) => {
        if (activeFilter === '*') return true;
        // Clean out the leading dot selector '.' from the passed filter value (e.g., '.filter-research' -> 'filter-research')
        return item.filterClass === activeFilter.replace('.', '');
    });

    return (
        <div className="row portfolio-container" data-aos="fade-up" data-aos-delay="200">
            {filteredData.map((data, index) => (
                <PortfolioItem key={'portfolioitem' + index} {...data} />
            ))}
        </div>
    );
};

export default PortfolioContainer;